import "date-fns";
import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TableContainer,TableFooter
} from "@material-ui/core";
import Style from "../style.module.scss";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import getMuiTheme from "../misTheme";

const ContractorRaReport = props => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);
  const [smallScreen, setSmallScreen] = useState(window.innerWidth <= 760);

  const [totalQuantity, setTotalQuantity] = useState([]);
  let columns = [];
  console.log(props.newWbs)
  if (props.ReportFormat == "Contractor Wise") {
    columns = [
      {
        name: "mat",
        label: "Contractor Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "masadt",
        label: "Values",
        options: {
          filter: true,
          sort: true,
        },
      },
    ];
  } else if (props.ReportFormat == "Item Wise") {
    columns = [
      {
        name: "mat",
        label: "Item Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "masadt",
        label: "Values",
        options: {
          filter: true,
          sort: true,
        },
      },
    ];
  }
  const tempQualityRes = (arr,elemIndex)=>{
    let totalQuantitytemp = [...totalQuantity]
    totalQuantitytemp[elemIndex]=0
    arr.map((item, index) => {
      if(item.number !='' ){
        if(item.number)
        totalQuantitytemp[elemIndex]=parseFloat(totalQuantitytemp[elemIndex])+parseFloat(item.number)
      }
      item.serial = index + 1;
    });
    return totalQuantitytemp;
  }
  useEffect(() => {
    const tempData = [];
    props.newWbs.forEach((elem, elemIndex) => {
      let row = [];
      if (props.ReportFormat == "Contractor Wise") {
        let totalQuantitytemp = tempQualityRes(elem.elm,elemIndex);

        row.push(
          elem.mat,
          <div>
            <MuiThemeProvider theme={getMuiTheme()}>

            <MUIDataTable
                data={elem.elm}
                columns={[ {
                  name: "serial",
                  label: "Serial No"
                 },{
                  name: "date",
                  label: "Date",
                },
                {
                  name: "item",
                  label: "Item",
                },
                {
                  name: "number",
                  label: "Quanity",
                },
                {
                  name: "unit",
                  label: "unit",
                },
                ]
                }
                options={{
                  selectableRows: "none",
                  responsive: smallScreen ? "scroll" : "simple",
                  pagination: false,
                  download: false,
                  viewColumns: false,
                  filter: true,
                  print: false,
                  setTableProps: () => ({className: "tableInside"}),
                  customFooter: (
                    ) => {
                      return (
                        <TableFooter>
                          <TableRow>
                            <TableCell variant="h4" colSpan={6} style={{float:'right',border:'none'}}>
                            Total Quantity:{totalQuantity[elemIndex] ? totalQuantity[elemIndex].toFixed(2):totalQuantitytemp[elemIndex].toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      );
                    },
                    onFilterChange: (changedColumn,filterList,type,changedColumnIndex,displayData)=>{
                      let templist= []
                      displayData.forEach(ele1 => {
                        
                        console.log(ele1)
                        templist.push({number:ele1.data[3]})
                      });

                      let totalequipmentQuantity = tempQualityRes(templist,elemIndex);

                      setTotalQuantity(totalequipmentQuantity)
                    }
                }}
              />
            
            </MuiThemeProvider>
          </div>
        );
      } else if (props.ReportFormat == "Item Wise") {
        let totalQuantitytemp = tempQualityRes(elem.elm,elemIndex);

        row.push(
          elem.mat,
          <div>
            <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
                data={elem.elm}
                columns={[ {
                  name: "serial",
                  label: "Serial No"
                 },{
                  name: "date",
                  label: "Date",
                },
                {
                  name: "contractor",
                  label: "Contractor",
                },
                {
                  name: "number",
                  label: "Quanity",
                },
                {
                  name: "unit",
                  label: "unit",
                },
                ]
                }
                options={{
                  selectableRows: "none",
                  responsive: smallScreen ? "scroll" : "simple",
                  pagination: false,
                  download: false,
                  viewColumns: false,
                  filter: true,
                  print: false,
                  setTableProps: () => ({className: "tableInside"}),
                  customFooter: (
                    ) => {
                      return (
                        <TableFooter>
                          <TableRow>
                            <TableCell variant="h4" colSpan={6} style={{float:'right',border:'none'}}>
                            Total Quantity:{totalQuantity[elemIndex] ? totalQuantity[elemIndex].toFixed(2):totalQuantitytemp[elemIndex].toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      );
                    },
                    onFilterChange: (changedColumn,filterList,type,changedColumnIndex,displayData)=>{
                      let templist= []
                      displayData.forEach(ele1 => {
                        templist.push({number:ele1.data[3]})
                      });

                      let totalequipmentQuantity = tempQualityRes(templist,elemIndex);

                      setTotalQuantity(totalequipmentQuantity)
                    }
                }}
              />
            </MuiThemeProvider>
          </div>
        );
      }

      tempData.push(row);
    });

    setData(tempData);
  }, [totalQuantity]);

  return (
    <>
       <Grid container className={Style.container___info}>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              style={{ marginLeft: "0.5em" }}
            >
              Project Name:{props.projectName}
            </Typography>
          </Grid>
        </Grid>

        <div className={Style.table___box}>
          {props.newWbs !== undefined && (
            <MUIDataTable
              title={
                props.ReportFormat == "Contractor Wise"
                  ? `Contractor wise item report`
                  : "Item wise Contractor  report"
              }
              data={data}
              columns={columns}
              options={{
                selectableRows: "none",
                responsive: smallScreen ? "standard" : "simple",
                pagination: false,
                download: false,
                viewColumns: false,
                filter: false,
                print: false,
              }}
            />
          )}
        </div>
    </>
  );
};
export default ContractorRaReport;
